import Swal from "sweetalert2";
import $ from "jquery";
import "select2";
import "select2/dist/css/select2.min.css";

export interface Select2Option {
  id: string | number;
  text: string;
}

/** SweetAlert dialog with a searchable (select2) dropdown. Resolves the chosen id, or null when cancelled. */
export async function pickWithSelect2(opts: {
  title: string;
  placeholder: string;
  options: Select2Option[];
  confirmText?: string;
}): Promise<string | null> {
  const selectId = `swal-s2-${Date.now()}`;
  const escape = (t: string) => t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
  const html =
    `<select id="${selectId}" style="width:100%"><option></option>` +
    opts.options.map((o) => `<option value="${escape(String(o.id))}">${escape(o.text)}</option>`).join("") +
    `</select>`;
  const result = await Swal.fire({
    title: opts.title,
    html,
    showCancelButton: true,
    confirmButtonText: opts.confirmText || "Valider",
    cancelButtonText: "Annuler",
    reverseButtons: true,
    didOpen: (popup) => {
      const $sel = $(`#${selectId}`);
      $sel.select2({
        width: "100%",
        placeholder: opts.placeholder,
        dropdownParent: $(popup),
        language: { noResults: () => "Aucun résultat" },
      });
      $sel.select2("open");
    },
    preConfirm: () => {
      const v = $(`#${selectId}`).val();
      if (!v) {
        Swal.showValidationMessage("Faites un choix.");
        return false;
      }
      return String(v);
    },
    willClose: () => {
      try {
        $(`#${selectId}`).select2("destroy");
      } catch {
        /* already destroyed */
      }
    },
  });
  return result.isConfirmed ? (result.value as string) : null;
}
